module.exports = __webpack_public_path__ + "media/images/emblems/Cortebert-coat_of_arms-da52c50f858766399c246f202b6a8fb4.svg";